


































import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PaginationModel, VHeaders } from '@/models/pagedlistmodel';
import { Shift } from '@/models/admin/shift';
import { Base } from '@/components/common/base';
import { IDialogOption } from '@/models/dialog';
import {getShiftHeaders} from '@/views/admin/shift/shift';
import {shiftService} from '@/shared';

@Component({
    props: ['methodName', 'progress'],
    computed: {
        methodtoCall: {
            get() {
                return this.$props.methodName;
            },
        },
    },
    components: {
        Grid: () => import('@/components/common/app.grid.vue'),
        Stores: () => import('@/components/common/store.select.vue'),
        AppDialog: () => import('@/components/common/app.dialog.vue'),
    },
})
export default class ShiftListPage extends Base {
    public headers: VHeaders[] = getShiftHeaders(this);
    public pagedShifts: Shift[] = [];
    public pagination = new PaginationModel('name');
    public loading: boolean = false;
    public storeId: number;
    public actions: any[] = [];
   
    public deleteDialog: IDialogOption = {
        width: 400,
        title: this.$parent.$t('shifts.deleteDialogTitle') as string,
        model: false,
        action: { color: 'success', icon: 'fas fa-check', text: 'Agree' },
        loading: false,
        onAction: (): void => {
            this.deleteShift();
        },
    };
    public shiftToDelete: Shift = {
        id: 0,
        name: '',
        startTime: '',
        endTime: '',
    };
    public preventPaginationCall: boolean = false;
    public setActions() {
        this.actions = [{
            type: 'link',
            icon: 'fas fa-edit',
            title: this.$t('shifts.shiftGridHeaders.gridAction.edit') as string,
            action: (model: Shift, storeId: string) => {
                // console.log(model);
                return {
                    name: 'admin.shifts.edit', params: { id: model.id, storeId: this.storeId },
                };
            },
        }, {
            type: 'button',
            icon: 'fas fa-trash-alt',
            title: this.$t('shifts.shiftGridHeaders.gridAction.delete') as string,
            color: 'error',
            action: (model: Shift, storeId: string) => { this.confirmDelete(model); },
        },
        ];
    }

    public created() {
        if (this.$route.params.storeId) {
            this.storeId = Number(this.$route.params.storeId);
        } else {
            this.storeId = this.userSession.storeId;
        }
    }

    public beforeDestroy() {
        const buttons = [];
        this.$emit('updateToolBar', buttons);
    }
    public callMethod(methodName): void {
        if (methodName === 'addShift') {
            this.$router.push({ name: 'admin.shifts.add', params: { storeId: this.storeId.toString() } });
        }
    }
    public updateToolBar(): void {
        const buttons: any = [];
        buttons.push({ id: '0', type: 'button', title: this.$t('shifts.btnAddShift'), disabled: false, visible: true, class: 'btn', label: this.$t('shifts.btnAddShift'), click: 'addShift', icon: 'fas fa-plus-circle' });
        this.$emit('updateToolBar', buttons);
    }
    public mounted() {
        // activating tab
        this.$root.$emit('sidebar.layout.vue', 'shifts');

        // Toolbar
        this.updateToolBar();
        this.$watch('methodtoCall', (newVal, oldVal) => {
            if (newVal) {
                this.callMethod(newVal);
            }
        });
        this.setActions();
        if (!this.isAuthorizedToAccess(['SuperAdmin', 'T-Admin', 'E-Admin'])) {
            this.getShifts();
        }
    }
    public async getShifts(): Promise<void> {
        try {
            this.loading = true;
            const shifts = await shiftService.getShifts(this.storeId, this.pagination);
            this.pagedShifts = shifts.results;
            this.pagination.totalItems = shifts.total;
        } finally {
            this.loading = false;
        }
    }
    public updatePaging(paging: any) {
        this.pagination = paging;
    }
    public confirmDelete(item: Shift): void {
        this.deleteDialog.model = true;
        this.shiftToDelete = item;
    }
    public async deleteShift(): Promise<void> {
        try {
            this.deleteDialog.loading = true;
            await shiftService.delete(this.shiftToDelete.id, this.storeId);
            this.deleteDialog.model = false;
            this.preventPaginationCall = true;
            this.showAlert(true, this.$t('shifts.alertDeleteShift'));
            this.getShifts();
        } finally {
            this.deleteDialog.loading = false;
        }

    }
    public updateStore(storeId: number): void {
        this.storeId = storeId;
        this.getShifts();
    }
}
